import { t } from 'ttag';

import { DEFAULT_STYLE_CONFIG } from './shared';

// These are the API's appliedEntityType values, so the form value ships as-is.
export const COMPANY_DISPLAY_MODE = {
  GROUP: 'company_groups',
  SPECIFIC: 'specific_companies',
  SHOW_ALL: 'all',
};

export const getCompanyDisplayOptions = () => [
  { label: t`Company Group`, value: COMPANY_DISPLAY_MODE.GROUP },
  { label: t`Specific Companies`, value: COMPANY_DISPLAY_MODE.SPECIFIC },
  { label: t`Show All`, value: COMPANY_DISPLAY_MODE.SHOW_ALL },
];

// Companies have no Order by picker; every mode but Specific sorts by name.
export const COMPANY_DEFAULT_SORT = 'name';

// Always shown, so it isn't a checkbox.
export const COMPANY_NAME_FIELDS = ['name'];

// -> fieldConfig.viewFields, left column of the checklist.
export const getCompanyFieldOptions = () => [
  { label: t`Company Logo`, value: 'logo' },
  { label: t`About`, value: 'about' },
  { label: t`Location`, value: 'location' },
];

// Right column, nested under a Contact Information parent. That parent is a
// select-all over these, not a token the API knows about.
export const getContactFieldOptions = () => [
  { label: t`Phone Number`, value: 'phone' },
  { label: t`Website`, value: 'website' },
  { label: t`Facebook`, value: 'facebook_url' },
  { label: t`X (formerly Twitter)`, value: 'twitter_url' },
  { label: t`LinkedIn`, value: 'linkedin_url' },
];

// Square logos, both filters on, groups titled.
export const COMPANIES_STYLE_CONFIG = {
  ...DEFAULT_STYLE_CONFIG,
  widgetFilters: { showSearch: true, alphabeticalSorting: true },
  displayGroupsAsTitles: true,
};
